import React from 'react';
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
} from 'mdb-react-ui-kit';
import { ImportSummary } from '../components/importSummary';

function SummaryPage() {
    return (
      <>
        <div className='d-flex flex-column my-5' >
          <ImportSummary />
        </div>
      </>
    );
}

export default SummaryPage;
